import React from 'react'

export const SearchForm = () => {
    return (
        <div className="search_form_menu_personal">
            <div className="menu_mobile_large_close">
                <span className="jl_close_wapper search_form_menu_personal_click"><span className="jl_close_1" /><span className="jl_close_2" /></span>
            </div>
            <form method="get" className="searchform_theme" action="#">
                <input type="text" placeholder="Search..." defaultValue name="s" className="search_btn" /><button type="submit" className="button"><i className="jli-search" /></button>
            </form>
        </div>
    )
};